module.exports = __webpack_public_path__ + "media/images/icon-bank-6b99fff204179cce22ca1624eb8dbfbe.svg";